import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import ImavenLoadingScreen from '../components/Helpers/loading-screen';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loginWithRedirect, isLoading } = useAuth0();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      // Capture the current path with query params
      const returnToUrl = location.pathname + location.search;
      // If the URL is for setMetting, store it in localStorage
      if (location.pathname.includes('/setMetting')) {
        localStorage.setItem('last_setmetting_url', returnToUrl);
      }

      // /consultations?email=x (and /?email=x) come from imavenai.com and the advice-ready email;
      // consultations now live on Home. The Auth0 callback lands on '/' without the query, so App.js
      // needs it back (sessionStorage, consumed right after login): we store the Home URL with the
      // query kept. The email is passed as login_hint so Auth0 pre-fills it (the visitor can still
      // switch to sign-up or another account on the Auth0 page).
      const authorizationParams = {};
      const params = new URLSearchParams(location.search);
      const isConsultationLink = location.pathname === '/consultations'
        || (location.pathname === '/' && params.has('email'));
      if (isConsultationLink) {
        try { sessionStorage.setItem('return_to_after_login', '/' + location.search); } catch { /* storage blocked */ }
        const hint = (params.get('email') || '').trim();
        if (/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(hint)) authorizationParams.login_hint = hint;
      }

      // Trigger login with the current URL as the return destination
      loginWithRedirect({
        appState: { returnTo: returnToUrl },
        ...(Object.keys(authorizationParams).length ? { authorizationParams } : {}),
      });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect, location]);

  if (isLoading) {
    return (
      <div style={{ 
        position: 'fixed', 
        top: 0, 
        left: 0, 
        width: '100vw', 
        height: '100vh', 
        background: 'linear-gradient(180deg, #f9fbff 0%, #f5f8fd 100%)',
        zIndex: 9999,
        overflow: 'hidden'
      }}>
        <ImavenLoadingScreen fullscreen />
      </div>
    );
  }

  return isAuthenticated ? children : null;
};

export default ProtectedRoute;
